/**
 * Barrel re-export for the xyflow mapping subsystem.
 *
 * The implementation is split across `model/xyflow/`:
 *   - `types.ts`     — public type surface (WorkflowNode/Edge/Graph, ...)
 *   - `layout.ts`    — Sugiyama barycenter layout (computeLevels, assignYOrder)
 *   - `toXyflow.ts`  — workflowToXyflow
 *   - `fromXyflow.ts`— xyflowToWorkflow
 *   - `stepIds.ts`   — generateStepId, renameStepInGraph
 *
 * Existing call sites import from `'model/xyflowMapping'`; the barrel keeps
 * those imports working unchanged.
 */
export type {
  ControlEdgeData,
  FlattenedStep,
  WorkflowEdge,
  WorkflowEdgeData,
  WorkflowGraph,
  WorkflowNode,
  WorkflowNodeData,
} from './xyflow/types';

export { computeLevels, assignYOrder } from './xyflow/layout';
export { workflowToXyflow } from './xyflow/toXyflow';
export { xyflowToWorkflow } from './xyflow/fromXyflow';
export { generateStepId, renameStepInGraph } from './xyflow/stepIds';
